var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9375 44.6807L32.7846 41.5278L30.8404 43.4721L35.9375 48.5692L45.1596 39.3471L43.2154 37.4028L35.9375 44.6807Z",
    fill: "#475168"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 32.1407V27.375C49 24.4576 47.8411 21.6597 45.7782 19.5968C43.7153 17.5339 40.9174 16.375 38 16.375C35.0826 16.375 32.2847 17.5339 30.2218 19.5968C28.1589 21.6597 27 24.4576 27 27.375V32.1421C24.3502 34.9397 22.8739 38.6467 22.875 42.5C22.875 50.8517 29.6483 57.625 38 57.625C46.3545 57.625 53.125 50.8517 53.125 42.5C53.125 38.4864 51.5506 34.8495 49 32.1407ZM29.75 27.375C29.75 22.8251 33.4501 19.125 38 19.125C42.5499 19.125 46.25 22.8251 46.25 27.375V29.8335C43.7982 28.2278 40.9308 27.3733 38 27.375C35.0692 27.3733 32.2018 28.2278 29.75 29.8335V27.375ZM38 54.875C31.1649 54.875 25.625 49.3351 25.625 42.5C25.625 35.6649 31.1649 30.125 38 30.125C44.8351 30.125 50.375 35.6649 50.375 42.5C50.375 49.3351 44.8351 54.875 38 54.875Z",
    fill: "#475168"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    fill: "#475168",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.673ecd6eab521b873b0113ae3496df95.svg";
export { ForwardRef as ReactComponent };